import React, { Dispatch, SetStateAction } from 'react'
import { Network } from '../../../services/token.service'
import { HelptipIcon } from '../../../svgIcons/HelptipIcon'

const errors = {
    invalidFee: 'Enter a valid fee',
    outOfRange: 'Your position will not earn fees or be used in trades until the market price moves into your range'
}

function FeeTierStep(props: {
    fee: number
    setFee: Dispatch<SetStateAction<number>>
    feeOptions: number[]
    token1: string
    token2: string
    error: string
    onSelectFeeCreatePool: (fee: number) => void
    isLoading: boolean
    isCreatePool?: boolean
    network: Network
}) {
    const { fee, setFee, feeOptions, token1, token2, error, isLoading, onSelectFeeCreatePool, network, isCreatePool = false } = props

    function updateFee(num: number) {
        if (token1 && token2) setFee(num)
    }

    function renderFeeOption(feeAmount: number, bestFor: string, isRecommended: boolean, isLast: boolean, icon?: string, isDisabled = false) {
        const isSelected = fee === feeAmount
        return (
            <div
                onClick={() => {
                    isDisabled ? onSelectFeeCreatePool(feeAmount) : updateFee(feeAmount)
                    // isDisabled ? console.log('disabled') : setFee(feeAmount)
                }}
                className={`max-w-[105px] mb-2 lg:mb-0 flex-1 p-4 flex items-start justify-center ${
                    isDisabled ? 'cursor-pointer border-dashed' : 'cursor-pointer'
                } relative rounded-[16px] border-[1px] border-[${
                    // className={`flex-1 p-4 flex items-start justify-center ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'} relative rounded-[16px] border-[1px] border-[${
                    isSelected ? '#0AE8F9' : '#0C3F6D'
                }] py-2 flex flex-col ${isLast ? '' : 'mr-4'}`}>
                <div className=' flex items-center justify-between w-full'>
                    {isDisabled ? <div className='absolute w-full h-full top-0 left-0 bg-[#0C1647] opacity-[0.8] rounded-[16px]' /> : null}
                    <span className='select-none font-bold text-white text-[14px]'>{`${feeAmount}%`}</span>
                    <div className=' flex items-center z-[10]'>
                        <div className='ml-2 group flex'>
                            <HelptipIcon className='w-5 text-[#6F6E8F] h-5' />
                            <span className='w-[170px] right-0 group-hover:visible invisible group-hover:opacity-100 transition-opacity bg-[#242C58] text-sm text-gray-100 rounded-md absolute opacity-0 top-[30px] p-3 z-[1]'>
                                {bestFor}
                            </span>
                        </div>
                    </div>
                </div>

                {/* {<span className='text-[12px]'>{bestFor}</span>} */}
                {/* {isCreatePool ? <span className='text-[12px]'>{bestFor}</span> : null} */}
            </div>
        )
    }

    function renderStepFeeTier() {
        return (
            <div className='flex flex-col'>
                <div className='justify-between items-center flex mb-2'>
                    <div className='flex flex-col'>{<span className='text-[18px] text-white font-bold block mb-[14px]'>{`Fee Tier`}</span>}</div>
                </div>
                {
                    <div className='flex flex-wrap lg:flex-nowrap'>
                        {network === 'mainnet-alpha'
                            ? null
                            : renderFeeOption(0.001, 'Best for high volume stable pairs', true, false, '🚀', !feeOptions || !feeOptions.includes(10))}
                        {renderFeeOption(0.01, 'Best for very stable pairs', true, false, '🚀', !feeOptions || !feeOptions.includes(100))}
                        {renderFeeOption(0.05, 'Best for stable pairs', true, false, '🚀', !feeOptions || !feeOptions.includes(500))}
                        {renderFeeOption(0.3, 'Best for most pairs', false, false, undefined, !feeOptions || !feeOptions.includes(3000))}
                        {renderFeeOption(1, 'Best for exotic pairs', false, true, undefined, !feeOptions || !feeOptions.includes(10000))}
                    </div>
                }
                {isLoading && token1 && token2 && feeOptions && feeOptions.length === 0 ? (
                    <span className='mt-2 text-[#FF3D3D] font-bold text-[16px]'>There is no pool for this pair yet</span>
                ) : null}
                {error && error === errors.invalidFee ? (
                    <div style={{ background: 'rgba(255, 83, 83, 0.20)' }} className='rounded-xl font-bold mt-4 p-4 text-[#FF5353]'>
                        Invalid Fee. Please enter a valid fee between 0.0001% and 10%
                    </div>
                ) : null}
            </div>
        )
    }

    return renderStepFeeTier()
}

export default FeeTierStep
